import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlbumActions } from '../video-detail-access';

/** Title, meta, description, album actions and sale countdown. Presentation only: actions are emitted to the page. */
@Component({
  selector: 'app-vd-info',
  templateUrl: './vd-info.component.html',
})
export class VdInfoComponent {
  @Input() title = '';
  @Input() networkName = '';
  @Input() metaLine: string[] = [];
  @Input() description = '';
  @Input() descriptionIsLong = false;
  @Input() actions: AlbumActions;
  @Input() countdown: { days: number; hours: number; minutes: number; seconds: number } | null = null;
  @Input() playLabel = 'Play';

  @Output() play = new EventEmitter<void>();
  @Output() subscribeAlbum = new EventEmitter<void>();
  @Output() buyAlbum = new EventEmitter<void>();
  @Output() tip = new EventEmitter<void>();
  @Output() polls = new EventEmitter<void>();

  descriptionOpen = false;
}
